// Import all store instances and their types from their respective modules
import agreementManagementStore, {
  AgreementManagementStore,
} from "./agreement-management-store";
import authStore, { AuthStore } from "./auth-store";
import bookingManagementStore, {
  BookingManagementStore,
} from "./booking-management-store";
import categoryManagementStore, {
  CategoryManagementStore,
} from "./category-management-store";
import customerManagementStore, {
  CustomerManagementStore,
} from "./customer-management-store";
import headquarterStore, { HeadquarterStore } from "./headquarter-store";
import masterManagementStore, {
  MasterManagementStore,
} from "./master-management-store";
import optionMenuStore, { OptionMenuStore } from "./option-menu-store";
import preferencesStore, { PreferencesStore } from "./preferences-store";
import productManagementStore, {
  ProductManagementStore,
} from "./product-management-store";
import smrStore, { SMRStore } from "./sales-medical-record-store";
import reservationSchedulerStore, {
  ReservationSchedulerStore,
} from "./reservation-schedular-store";
import shiftManagementStore, {
  ShiftManagementStore,
} from "./shift-management-store";
import staffManagementStore, {
  StaffManagementStore,
} from "./staff-management-store";
import storeManagementStore, {
  StoreManagementStore,
} from "./store-management-store";
import treatmentManagementStore, {
  TreatmentManagementStore,
} from "./treatment-management-store";
import storeCmsStore, { StoreCmsStore } from "./store-cms-store";
import userStore, { UserStore } from "./user-store";
import inventoryStore, { InventoryStore} from "./inventory-mangement-store";
import emailManagementStore, { EmailManagementStore } from "./email-management-store";
import dashboardStore, { DashboardStore } from "./dashboard-store";
import totallingManagementStore, { TotallingManagementStore } from "./totalling-management-store";

// Define the RootStore type, which aggregates all individual store types
export type RootStore = {
  authStore: AuthStore;
  preferencesStore: PreferencesStore;
  userStore: UserStore;
  storeManagementStore: StoreManagementStore;
  staffManagementStore: StaffManagementStore;
  treatmentManagementStore: TreatmentManagementStore;
  productManagementStore: ProductManagementStore;
  categoryManagementStore: CategoryManagementStore;
  shiftManagementStore: ShiftManagementStore;
  masterManagementStore: MasterManagementStore;
  optionMenuStore: OptionMenuStore;
  customerManagementStore: CustomerManagementStore;
  bookingManagementStore: BookingManagementStore;
  agreementManagementStore: AgreementManagementStore;
  headquarterStore: HeadquarterStore;
  reservationSchedulerStore: ReservationSchedulerStore;
  smrStore: SMRStore;
  storeCmsStore: StoreCmsStore;
  inventoryStore: InventoryStore;
  emailManagementStore: EmailManagementStore;
  dashboardStore: DashboardStore;
  totallingManagementStore: TotallingManagementStore;
};

// Create the rootStore instance, containing all store instances
const rootStore: RootStore = {
  authStore,
  preferencesStore,
  userStore,
  storeManagementStore,
  staffManagementStore,
  treatmentManagementStore,
  productManagementStore,
  categoryManagementStore,
  shiftManagementStore,
  masterManagementStore,
  optionMenuStore,
  customerManagementStore,
  bookingManagementStore,
  agreementManagementStore,
  headquarterStore,
  reservationSchedulerStore,
  smrStore,
  storeCmsStore,
  inventoryStore,
  emailManagementStore,
  dashboardStore,
  totallingManagementStore
};

// Export the rootStore as the default export
export default rootStore;
